/**
 * A live line that says what the product is doing while the visitor waits. The words are the
 * interface. A pulsing mark is only there so the line is findable, not as a spinner that stands in
 * for copy.
 */
import * as stylex from "@stylexjs/stylex";
import type { ReactNode } from "react";
import "@lattice/tokens/color.stylex";
import { color } from "@lattice/tokens/color.stylex";
import "@lattice/tokens/motion.stylex";
import { motion } from "@lattice/tokens/motion.stylex";
import "@lattice/tokens/space.stylex";
import { radius, space } from "@lattice/tokens/space.stylex";
import "@lattice/tokens/text.stylex";
import { text } from "@lattice/tokens/text.stylex";
import "@lattice/tokens/breakpoints.stylex";
import { breakpoints } from "@lattice/tokens/breakpoints.stylex";
const pulse = "x1o401fz-B";
const styles = {
  mark: {
    kzqmXN: "x7rs3l3",
    kZKoxP: "xsf620a",
    kaIpWk: "x1m3fsnl",
    kmuXW: "x2lah0s",
    $$css: true
  },
  pending: {
    kWkggS: "xovxxy8",
    kKVMdj: "xlcs3up x1ah4f44",
    k44tkh: "xcdydla",
    kyAemX: "x4hg4is",
    ko0y90: "xa4qsjk",
    kILWW9: "xpz12be",
    $$css: true
  },
  ok: {
    kWkggS: "x1gadm0y",
    $$css: true
  },
  problem: {
    kWkggS: "xtx2pbi",
    $$css: true
  }
};
export type StatusState = "pending" | "ok" | "problem";
export function Status({
  children,
  state = "pending",
  live = true,
  testId
}: {
  readonly children: ReactNode;
  readonly state?: StatusState;
  /** False inside an alert, which is already a live region and would be read twice. */
  readonly live?: boolean;
  readonly testId?: string;
}) {
  return <p role={live ? "status" : undefined} data-testid={testId} className="x78zum5 x6s0dn4 x1173whf x1ghz6dp xl4dl4e x1jty25b x1fzhlzt">
      <span aria-hidden="true" {...stylex.props(styles.mark, state === "ok" ? styles.ok : state === "problem" ? styles.problem : styles.pending)} />
      <span>{children}</span>
    </p>;
}